export const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname

export const handleWheelInputNumber = (e: React.WheelEvent<HTMLInputElement>) => e.currentTarget.blur()